import { useEffect, useState, useCallback } from 'react';

/**
 * Composant qui vérifie périodiquement si une nouvelle version de l'app est disponible
 * et force le rechargement si nécessaire
 */
const VersionChecker = () => {
  const [isChecking, setIsChecking] = useState(false);

  const checkVersion = useCallback(async () => {
    if (isChecking) return;
    setIsChecking(true);

    try {
      // Récupérer le fichier index.html avec un paramètre de cache busting
      const response = await fetch(`/index.html?t=${Date.now()}`, {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          'Pragma': 'no-cache',
        }
      });

      if (!response.ok) {
        throw new Error('Erreur de récupération');
      }

      // Vérifier si le service worker a changé
      if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.ready;
        
        // Forcer la vérification des mises à jour
        await registration.update();
        
        // Si un nouveau service worker est en attente, forcer le rechargement
        if (registration.waiting) {
          console.log('🔄 Nouvelle version détectée - Rechargement forcé');
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
          setTimeout(() => {
            window.location.reload(true);
          }, 1000);
        }
      }
    } catch (error) {
      console.warn('⚠️ Erreur vérification version:', error);
    } finally {
      setIsChecking(false);
    }
  }, [isChecking]);

  useEffect(() => {
    // Vérifier la version au démarrage
    checkVersion();
    
    // Vérifier toutes les 2 minutes
    const interval = setInterval(checkVersion, 120000);
    
    return () => clearInterval(interval);
  }, [checkVersion]);

  return null; // Ce composant ne rend rien
};

export default VersionChecker;
